import {
    HttpResponse,
    DefectWorkplaceModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class DefectWorkplacesDataService implements CrudService<DefectWorkplaceModel, DefectWorkplaceModel> {
    getAll(query: CrudDataQuery<DefectWorkplaceModel>): Promise<CrudEnumerableResponse<DefectWorkplaceModel>> {
        return ApiService.api.getDefectWorkplaceBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<DefectWorkplaceModel>): Promise<CrudEnumerableResponse<DefectWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<DefectWorkplaceModel>> {
        return ApiService.api.getDefectWorkplaceById(id, params);
    }

    create(item: DefectWorkplaceModel, params?: RequestParams): Promise<CrudResponse<DefectWorkplaceModel>> {
        return ApiService.api.insertDefectWorkplace(item, params);
    }

    update(item: DefectWorkplaceModel, params?: RequestParams): Promise<DefectWorkplaceModel> {
        return ApiService.api.updateDefectWorkplace(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<DefectWorkplaceModel> {
        return ApiService.api.patchDefectWorkplace(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<DefectWorkplaceModel>): Promise<CrudEnumerableResponse<DefectWorkplaceModel>> {
        return ApiService.api.deleteDefectWorkplaces(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationDefectWorkplace(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<DefectWorkplaceModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: DefectWorkplaceModel, params?: RequestParams): Promise<CrudResponse<DefectWorkplaceModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getDefectWorkplaceGroupped(query, params);
    }

}

